import styles from './SectionsContainer.module.scss';
import { ReactNode } from 'react';
import { Heading } from '../text/Heading';
import { HeadingContextProvider } from '../text/HeadingContext';

interface Props {
  children: ReactNode;
  heading: string;
}

export function SectionsContainer(props: Props) {
  const sectionsContainer = [styles['section-container']]
    .filter(Boolean)
    .join(' ');
  return (
    <article className={sectionsContainer}>
      <Heading level={2}>{props.heading}</Heading>
      <HeadingContextProvider>{props.children}</HeadingContextProvider>
    </article>
  );
}
